module.exports = __webpack_public_path__ + "media/vine boom.13947fc2.mp3";